import { render } from "./CreateWhatsNewSideBar.vue?vue&type=template&id=38638a61&scoped=true"
import script from "./CreateWhatsNewSideBar.vue?vue&type=script&lang=js"
export * from "./CreateWhatsNewSideBar.vue?vue&type=script&lang=js"

import "./CreateWhatsNewSideBar.vue?vue&type=style&index=0&id=38638a61&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38638a61"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
